import moment from 'moment';
import { luftGet } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

// actions

const GET_AVAILABLE_VEHICLES = 'luft/on-time/GET_AVAILABLE_VEHICLES';
const GET_AVAILABLE_VEHICLES_SUCCESS =
  'luft/on-time/GET_AVAILABLE_VEHICLES_SUCCESS';
const GET_AVAILABLE_VEHICLES_FAILURE =
  'luft/on-time/GET_AVAILABLE_VEHICLES_FAILURE';

// reducer

const initialState = {
  isFetching: false,
  error: '',
  requested: '',
  list: [],
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_AVAILABLE_VEHICLES:
      return {
        ...state,
        isFetching: true,
        error: '',
        requested: moment().format('YYYY-MM-DD HH:mm:ss'),
      };

    case GET_AVAILABLE_VEHICLES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: '',
        list: action.list.availableVehicles,
      };

    case GET_AVAILABLE_VEHICLES_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };

    default:
      return state;
  }
}

export default reducer;

// actions creators

function _getAvailableVehicles() {
  return { type: GET_AVAILABLE_VEHICLES };
}

function _getAvailableVehiclesSuccess(list) {
  return {
    type: GET_AVAILABLE_VEHICLES_SUCCESS,
    list,
  };
}

function _getAvailableVehiclesFailure(error) {
  return {
    type: GET_AVAILABLE_VEHICLES_FAILURE,
    error,
  };
}

// thunk action creators

export function getAvailableVehicles(params) {
  return async function (dispatch) {
    // -disable-next-line consistent-return
    return (async () => {
      dispatch(_getAvailableVehicles());

      try {
        const response = await luftGet('/OnTime/GetAvailableVehicles', params);
        dispatch(_getAvailableVehiclesSuccess(response.data));
        return response.data;
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getAvailableVehiclesFailure(error.message),
        );
      }
    })();
  };
}
